import { useQuery } from '@tanstack/react-query';
import { normalizeEventDetailResponse } from '../components/Events/mapApiEventToListItem';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const fetchEventDetail = async (api, eventId) => {
  const result = await api.getEventById(eventId);

  if (!result.success) {
    throw new Error(result.message || 'Failed to load event');
  }

  const event = normalizeEventDetailResponse(result.data);
  if (!event) {
    throw new Error('Event not found');
  }

  return event;
};

export const useEventQuery = (eventId, options = {}) => {
  const { enabled = true, refetchOnWindowFocus = false } = options;
  const { api, queryKeys } = useEventsScope();

  return useQuery({
    queryKey: queryKeys.detail(eventId),
    enabled: Boolean(eventId) && enabled,
    refetchOnWindowFocus,
    queryFn: () => fetchEventDetail(api, eventId),
  });
};
